<template>
  <div class="topDiv">
    <section class="d-flex align-items-center justify-content-between w-100">
      <label class="teams-label-font"
        >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
      >
      <div class="position-relative">
        <b-button
          style="padding: 3px 7px !important"
          class="acs-addBtn-modal px-2"
          v-if="field && field.key === 'description'"
          :class="showAILoader ? 'ai-loader-class defaultCursor' : 'pointer'"
          @click="!showAILoader ? $emit('write-with-hire3x', field) : ''"
          :disabled="writeButtonDisabled"
        >
          <div
            class="d-flex align-items-center justify-content-center w-100 h-100"
          >
            Write with Hire3x
            <img
              class="ml-1"
              src="../../assets/newJD/job-desc-ai-button.svg"
              alt=""
            />
          </div>
        </b-button>
        <div v-if="showAILoader" class="ai-loader-pos">
          <Loader />
        </div>
      </div>
    </section>
    <quill-editor
      class="mt-2 custom-quill-editor p-0"
      :disabled="disabled"
      :type="type"
      :placeholder="placeholder"
      :id="id"
      v-model.trim="inputData"
      @input="handleInput"
      @blur="handleBlur"
      :class="{
        bindingClass: disabled,
        error: showError || showValidationError,
        'disablepointer disablequilleditor': disabled,
      }"
      :options="editorOption"
    >
    </quill-editor>
  </div>
</template>

<script>
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Loader from "../fixedcomponents/Loader.vue";
export default {
  name: "CustomQuillEditor",
  components: {
    quillEditor,
    Loader,
  },
  props: {
    bindingClass: String,
    writeButtonDisabled: Boolean,
    disabled: Boolean,
    mandatory: Boolean,
    showError: Boolean,
    showAILoader: Boolean,
    type: String,
    label: String,
    placeholder: String,
    id: String,
    limit: Number,
    field: Object,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },

  data() {
    return {
      inputData: "",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [
              {
                list: "ordered",
              },
              {
                list: "bullet",
              },
            ],
          ],
          keyboard: {
            bindings: {
              tab: {
                key: 9,
                handler: (range, context) => {
                  context.quill.insertText(range.index, "\t");
                  context.quill.setSelection(range.index + 1);
                },
              },
            },
          },
        },
        preserveWhitespace: true,
        placeholder: this.placeholder,
      },
      showValidationError: false,
    };
  },

  created() {
    if (this.vmodel) {
      this.inputData = this.vmodel;
    }
  },
  watch: {
    inputData(newValue) {
      this.validateInput(newValue);
    },
    vmodel(newValue) {
      this.inputData = newValue;
    },
  },
  methods: {
    validateInput(value) {
      if (this.mandatory && this.isEmpty(value)) {
        this.showValidationError = true;
      } else if (
        this.limit &&
        this.removeTags(value).length > parseInt(this.limit)
      ) {
        this.showValidationError = true;
      } else {
        this.showValidationError = false;
      }
    },
    handleInput() {
      let processedInput = this.inputData.replace(/^(<p><br><\/p>)+/, "");
      this.inputData = processedInput.trim();
      this.$emit("select-value", this.inputData);
      this.$emit("handle-input");
    },

    handleBlur() {
      this.$emit("handle-blur");
    },
    removeTags(value) {
      let plainText = value.replace(/<[^>]+>/g, ""); // Remove HTML tags
      plainText = plainText.replace(/&nbsp;/g, " "); // Replace &nbsp; with regular spaces
      plainText = plainText.trim();
      return plainText;
    },
    isEmpty(value) {
      return this.removeTags(value).length === 0;
    },
  },
};
</script>

<style>
.validationError {
  border: 1px solid red !important;
}
.ai-loader-class {
  opacity: 0.5;
  height: 27px;
  width: 153px;
}

.ai-loader-pos {
  position: absolute;
  top: -56px;
  z-index: 1;
  left: 37px;
}
</style>
